import { render, staticRenderFns } from "./SimulatedDispatchedOrder.vue?vue&type=template&id=c9b3d76c&scoped=true"
import script from "./SimulatedDispatchedOrder.vue?vue&type=script&lang=js"
export * from "./SimulatedDispatchedOrder.vue?vue&type=script&lang=js"
import style0 from "./SimulatedDispatchedOrder.vue?vue&type=style&index=0&id=c9b3d76c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b3d76c",
  null
  
)

export default component.exports